import gql from 'graphql-tag';

const QUERY_USER = gql`
  query user($userId: ID!) {
    user(userId: $userId) {
      isSuccess
      message
      user {
        id
        firstName
        lastName
        email
        createdAt
        createdBy {
          id
          firstName
          lastName
        }
      }
    }
  }
`;

export default QUERY_USER;
